document.addEventListener("DOMContentLoaded", () => {
  const unitGroups = document.querySelectorAll("[data-unit-input]");

  unitGroups.forEach((group) => {
    const input = group.querySelector("[data-measurement-input]");
    const select = group.querySelector("[data-unit-select]");

    // Default unit

    select.dataset.previousUnit = select.value;

    select.addEventListener("change", () => {
      const value = parseFloat(input.value);

      if (isNaN(value)) {
        select.dataset.previousUnit = select.value;
        return;
      }

      const previousUnit = select.dataset.previousUnit;
      const currentUnit = select.value;

      let convertedValue = value;

      // cm -> in
      if (previousUnit === "cm" && currentUnit === "in") {
        convertedValue = value / 2.54;
      }

      // in -> cm
      if (previousUnit === "in" && currentUnit === "cm") {
        convertedValue = value * 2.54;
      }

      input.value = convertedValue.toFixed(2);
      select.dataset.previousUnit = currentUnit;
    });
  });
});
